export default function HowToBuyPlan({ planName }: { planName: string }) {
  return (
    <section className="tw-py-20 tw-text-center tw-bg-white">
      <div className="tw-max-w-5xl tw-mx-auto tw-px-6">
        <h2 className="tw-text-3xl md:tw-text-[36px] tw-font-semibold tw-text-[#111]">
          How to buy the {planName}?
        </h2>

        {/* line breaks follow the design on lg+; text wraps freely below */}
        <p className="tw-mt-12 tw-text-base tw-leading-7 tw-text-gray-500 lg:[&>span]:tw-block lg:[&>span]:tw-whitespace-nowrap">
          <span>
            You can add {planName} to your cart when you buy an IZICart product
            on{" "}
          </span>
          <span>
            <a
              href="https://www.izicart.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="tw-font-semibold tw-text-[#111] tw-underline tw-underline-offset-4"
            >
              https://www.izicart.com/
            </a>
            . Product owners who are eligible for an {planName}{" "}
          </span>
          <span>can find an offer on IZICart’s website.</span>
        </p>
      </div>
    </section>
  );
}
